const G2Domain = process.env.REACT_APP_G2DOMAIN;
const server_product = process.env.REACT_APP_SERVER_PRODUCT;
const server_open_api = process.env.REACT_APP_SERVER_OPEN_API


export {
    server_product,
    G2Domain,
    server_open_api
};